import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

export const selectedRegionGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  const router = inject(Router);

  const selectedRegion = localStorage.getItem('selectedRegion');
  if (selectedRegion && selectedRegion.trim().length > 0) {
    return true;
  }

  return router.createUrlTree(['/model']);
};
